import { ActionButton } from "@fluentui/react";
import React from "react";

export interface IMainButtonProps {
    title: string;
    description: string;
    url?: string;
    onClick?: () => void;
    icon: string;
}

const MainButton = (props: IMainButtonProps): JSX.Element => {
    return <ActionButton
        style={{ height: '250px' }}
        className='ms-Grid-col ms-u-sm3 ms-depth-4 icon-96'
        onClick={() => {
            if (props.onClick != null)
                props.onClick()
            else
                window.location.href = props.url
        }}
        iconProps={{ iconName: props.icon }}
        styles={{ icon: { color: '#0078d4', fontSize: '70px', margin: '0 auto', marginTop: '.2em', lineHeight: 'inherit', verticalAlign: 'initial' } }}>
        <p className='ms-fontWeight-semibold ms-fontSize-l'>{props.title}</p>
        <p className='ms-fontSize-m'>{props.description}</p>
    </ActionButton>
}

export default MainButton;